module.exports = __webpack_public_path__ + "static/media/xqgz.17e5eaa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/xqgz.png
// module id = 692
// module chunks = 0 1